//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// UniswapV3PriceProvider
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0x9D46F86516d6083ACA3F9850D060CB62CD0F6924)
 */
export const uniswapV3PriceProviderAbi = [
  {
    type: 'constructor',
    inputs: [
      {
        name: '_priceProvidersRepository',
        internalType: 'contract IPriceProvidersRepository',
        type: 'address',
      },
      {
        name: '_factory',
        internalType: 'contract IUniswapV3Factory',
        type: 'address',
      },
      {
        name: '_priceCalculationData',
        internalType: 'struct UniswapV3PriceProvider.PriceCalculationData',
        type: 'tuple',
        components: [
          { name: 'periodForAvgPrice', internalType: 'uint32', type: 'uint32' },
          { name: 'blockTime', internalType: 'uint8', type: 'uint8' },
        ],
      },
    ],
    stateMutability: 'nonpayable',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'blockTime',
        internalType: 'uint8',
        type: 'uint8',
        indexed: false,
      },
    ],
    name: 'NewBlockTime',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'period',
        internalType: 'uint32',
        type: 'uint32',
        indexed: false,
      },
    ],
    name: 'NewPeriod',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'newPendingOwner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
    ],
    name: 'OwnershipPending',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'newOwner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
    ],
    name: 'OwnershipTransferred',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'asset',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'pool',
        internalType: 'contract IUniswapV3Pool',
        type: 'address',
        indexed: true,
      },
    ],
    name: 'PoolForAsset',
  },
  {
    type: 'function',
    inputs: [],
    name: 'acceptOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      {
        name: '_pool',
        internalType: 'contract IUniswapV3Pool',
        type: 'address',
      },
    ],
    name: 'adjustOracleCardinality',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: '_asset', internalType: 'address', type: 'address' }],
    name: 'assetOldestTimestamp',
    outputs: [
      { name: 'oldestTimestamp', internalType: 'uint32', type: 'uint32' },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: '_asset', internalType: 'address', type: 'address' }],
    name: 'assetSupported',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: '_blockTime', internalType: 'uint8', type: 'uint8' }],
    name: 'changeBlockTime',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: '_period', internalType: 'uint32', type: 'uint32' }],
    name: 'changePeriodForAvgPrice',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: '_asset', internalType: 'address', type: 'address' }],
    name: 'getPrice',
    outputs: [{ name: 'price', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      {
        name: '_pool',
        internalType: 'contract IUniswapV3Pool',
        type: 'address',
      },
    ],
    name: 'observationsStatus',
    outputs: [
      { name: 'bufferFull', internalType: 'bool', type: 'bool' },
      { name: 'enoughObservations', internalType: 'bool', type: 'bool' },
      { name: 'currentCardinality', internalType: 'uint16', type: 'uint16' },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'owner',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'pendingOwner',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: '', internalType: 'address', type: 'address' }],
    name: 'pools',
    outputs: [
      { name: '', internalType: 'contract IUniswapV3Pool', type: 'address' },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'priceCalculationData',
    outputs: [
      { name: 'periodForAvgPrice', internalType: 'uint32', type: 'uint32' },
      { name: 'blockTime', internalType: 'uint8', type: 'uint8' },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'priceProviderPing',
    outputs: [{ name: '', internalType: 'bytes4', type: 'bytes4' }],
    stateMutability: 'pure',
  },
  {
    type: 'function',
    inputs: [],
    name: 'priceProvidersRepository',
    outputs: [
      {
        name: '',
        internalType: 'contract IPriceProvidersRepository',
        type: 'address',
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      {
        name: '_pool',
        internalType: 'contract IUniswapV3Pool',
        type: 'address',
      },
    ],
    name: 'quotePrice',
    outputs: [{ name: 'price', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'quoteToken',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'removePendingOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'renounceOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      {
        name: '_pool',
        internalType: 'contract IUniswapV3Pool',
        type: 'address',
      },
      {
        name: '_currentObservationIndex',
        internalType: 'uint16',
        type: 'uint16',
      },
      {
        name: '_currentObservationCardinality',
        internalType: 'uint16',
        type: 'uint16',
      },
    ],
    name: 'resolveOldestObservationTimestamp',
    outputs: [
      { name: 'oldestTimestamp', internalType: 'uint32', type: 'uint32' },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '_asset', internalType: 'address', type: 'address' },
      {
        name: '_pool',
        internalType: 'contract IUniswapV3Pool',
        type: 'address',
      },
    ],
    name: 'setupAsset',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'newOwner', internalType: 'address', type: 'address' }],
    name: 'transferOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'newPendingOwner', internalType: 'address', type: 'address' },
    ],
    name: 'transferPendingOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'uniswapV3Factory',
    outputs: [
      { name: '', internalType: 'contract IUniswapV3Factory', type: 'address' },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '_asset', internalType: 'address', type: 'address' },
      {
        name: '_pool',
        internalType: 'contract IUniswapV3Pool',
        type: 'address',
      },
    ],
    name: 'verifyPool',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'view',
  },
] as const

/**
 * [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0x9D46F86516d6083ACA3F9850D060CB62CD0F6924)
 */
export const uniswapV3PriceProviderAddress = {
  1: '0x9D46F86516d6083ACA3F9850D060CB62CD0F6924',
} as const

/**
 * [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0x9D46F86516d6083ACA3F9850D060CB62CD0F6924)
 */
export const uniswapV3PriceProviderConfig = {
  address: uniswapV3PriceProviderAddress,
  abi: uniswapV3PriceProviderAbi,
} as const
